import type { CSSProperties, PropsWithChildren } from 'react';

import classNames from 'classnames';

export interface TableRowProps {
  style?: CSSProperties;
  hasBorder?: boolean;
  isHeaderRow?: boolean;
  hasSidePadding?: boolean;
}

export const TableRow = ({
  children,
  style,
  hasBorder = true,
  isHeaderRow = false,
  hasSidePadding = false,
}: PropsWithChildren<TableRowProps>) => (
  <div
    className={classNames('flex flex-col xl-msq:items-start self-start w-full', {
      'border-b': hasBorder,
      'border-base-border-light': hasBorder && !isHeaderRow,
      'border-base-border-medium': hasBorder && isHeaderRow,
      'px-6': hasSidePadding,
    })}
    data-qa="table-row"
    style={style}
  >
    {children}
  </div>
);
